import angular from 'angular';
import constants from 'app/constants';
import {
  oversightDataService,
  docDataService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService
} from 'app/services';
import {
  alerts
} from 'app/components/global';
import attachAgendaItemFolder from './attachAgendaItemFolder';
import attachAgendaItemDocument from './attachAgendaItemDocument';
import attachAgendaItemReportFolder from './attachAgendaItemReportFolder';
import attachAgendaItemReport from './attachAgendaItemReport';
import controller from './attach-agendaItem-dialog.controller';
import template from './attach-agendaItem-dialog.html';


class dialogService {
  getOptions($event, { serviceId, agendaItemId, folder }) {
    return {
      controller,
      controllerAs: 'attachAgendaItemDialogVM',
      locals: {
        serviceId,
        agendaItemId,
        folder
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.oversight.attachAgendaItemDialog', [
  alerts,
  oversightDataService,
  attachAgendaItemDocument,
  attachAgendaItemFolder,
  attachAgendaItemReport,
  attachAgendaItemReportFolder,
  constants,
  docDataService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
])
  .service('attachAgendaItemDialog', dialogService)
  .name;
